import React from "react";

export default function DoubleWaveIcon({
  size = 32,
  strokeWidth = 1.6, // thin
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="waveRedOrange1" x1="2" y1="9" x2="22" y2="9">
          <stop offset="0%" stopColor="#ef4444" />   {/* red */}
          <stop offset="100%" stopColor="#f97316" /> {/* orange */}
        </linearGradient>
        <linearGradient id="waveRedOrange2" x1="2" y1="15" x2="22" y2="15">
          <stop offset="0%" stopColor="#f97316" />   {/* orange */}
          <stop offset="100%" stopColor="#facc15" /> {/* orange‑yellow */}
        </linearGradient>
      </defs>

      {/* top wave */}
      <path
        d="
          M 2 9
          C 6 5, 10 5, 13 9
          S 20 13, 22 9
        "
        stroke="url(#waveRedOrange1)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* bottom wave, slightly shifted down */}
      <path
        d="
          M 2 15
          C 6 11, 10 11, 13 15
          S 20 19, 22 15
        "
        stroke="url(#waveRedOrange2)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
